<form #form="ngForm" class="motivo-perda-venda-oportunidade-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Gestão de Oportunidade
            </h6>
            <p class="form-text text-muted">
                Selecione em quais momentos este motivo deve ser exibido e ficar disponível para ser selecionado na gestão de oportunidades
            </p>
        </div>
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.causaPerdaOportunidade" name="causaPerdaOportunidade" id="causaPerdaOportunidade">
                    <label class="custom-control-label" for="causaPerdaOportunidade">Causa de Perda</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo como causa da perda de oportunidades</p>
            </li>
        </ul>
    </div>
</form>
